import { useQuery, useMutation } from "@tanstack/react-query";

import logger from "../../../../logger";

export const feedbackKeys = {
  all: ["feedback"],
  lists: () => [...feedbackKeys.all, "list"],
  list: (filters) => [...feedbackKeys.lists(), { filters }],
  items: () => [...feedbackKeys.all, "item"],
  item: (id) => [...feedbackKeys.items(), id],
};

export function useFeedback(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: feedbackKeys.item(args.id),
    queryFn: () => func(args.id),
    ...queryOptions,
  });
}

export function useFeedbacks(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: feedbackKeys.list(args.filters),
    queryFn: () => func(args.filters),
    ...queryOptions,
  });
}

export function useCreateFeedback(func) {
  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: (data) => {
      return data;
    },
  });
}
